// extracted by extract-css-chunks-webpack-plugin
module.exports = {"itemPriceData":"-Bzbz","shopTheLookContainer":"PP9cx"};